function NotFound(): JSX.Element {
  return <h1> </h1>;
}

export default NotFound;
